import { createReducer } from '@reduxjs/toolkit';
import { getFaqPage } from '../actions/faqPage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getFaqPage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
